import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-sa-form',
  templateUrl: './sa-form.component.html',
  styleUrls: ['./sa-form.component.scss']
})
export class SaFormComponent implements OnInit ,AfterViewInit{

  @Input()
  saForm:any;
  @ViewChild('saModal')
  saFormModal:any;
  saImagePath:any="";
  constructor() { }
  ngAfterViewInit(): void {
    setTimeout(()=>{
      if(this.saForm!=undefined){
        this.saImagePath=this.saForm;
        this.saFormModal.show();
      }
    })
   
  }

  ngOnInit(): void {
    if(this.saForm!=undefined){
      // this.saImagePath=this.saForm;
      // this.saFormModal.show();
    }
  }

}
